import styled, { css } from 'styled-components';
import { Swiper } from 'swiper/react';

import { BREAKPOINTS } from '@shared/styled-system';

import { IconWrapper } from '@components/button';

export const Wrapper = styled.div<{ $isReady?: boolean }>`
	position: relative;
	width: 100%;

	opacity: ${({ $isReady }) => ($isReady ? 1 : 0)};
	transition: opacity 0.1s ease-in-out;
`;

export const SwiperStyled = styled(Swiper)<{ $hasNavigation?: boolean }>`
	/* stylelint-disable no-unused-selectors */
	.swiper-button-next,
	.swiper-button-prev {
		display: none;
	}

	${({ $hasNavigation }) =>
		$hasNavigation &&
		css`
			@media (${BREAKPOINTS.DESKTOP}) {
				margin: 0 54px;
			}
		`}
`;

export const SliderControls = styled.div<{ $isHidden: boolean; $isPrev: boolean; $isNext: boolean }>`
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	z-index: 99;
	display: ${({ $isHidden }) => ($isHidden ? 'none' : 'flex')};
	justify-content: space-between;
	width: 100%;
	pointer-events: none;

	&::before,
	&::after {
		content: '';
		position: absolute;
		top: -20px;
		bottom: -20px;
		width: 120px;
		z-index: -1;
		pointer-events: none;
		transition: opacity 0.3s ease;
	}

	&::before {
		left: 0;
		background: ${({ theme }) => `linear-gradient(to right, ${theme.colors.background.main} 0%, rgba(0,0,0,0) 100%)`};
		opacity: ${({ $isPrev }) => ($isPrev ? 1 : 0)};
	}

	&::after {
		right: 0;
		background: ${({ theme }) => `linear-gradient(to left, ${theme.colors.background.main} 0%, rgba(0,0,0,0) 100%)`};
		opacity: ${({ $isNext }) => ($isNext ? 1 : 0)};
	}

	@media (${BREAKPOINTS.NOT_DESKTOP}) {
		display: none;
	}

	& > button {
		pointer-events: auto;
		border-radius: 50%;
		min-width: 36px;
		min-height: 36px;
		height: 36px;
		width: 36px;
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;

		&:first-child {
			margin-left: 12px;
			${({ $isPrev }) =>
				!$isPrev &&
				css`
					opacity: 0.4;
					pointer-events: none;
					cursor: default;
					filter: grayscale(100%);
				`}
		}

		&:last-child {
			margin-right: 12px;
			${({ $isNext }) =>
				!$isNext &&
				css`
					opacity: 0.4;
					pointer-events: none;
					cursor: default;
					filter: grayscale(100%);
				`}
		}
	}

	${IconWrapper} {
		width: 24px;
		height: 24px;
	}
`;
